import { pipe, map } from "rxjs"
import { ProcessingStatus } from "src/app/core/enums/lead/processing-status.enum"
import { QualificationOutcome } from "src/app/core/enums/lead/qualification-outcome.enum"
import { QualificationStatus } from "src/app/core/enums/lead/qualification-status.enum"
import { LeadStatusTransition } from "src/app/core/models/lead/lead-status-transition.model"
import { LeadDto } from "src/app/infrastructure/lobby-proxy/DTOs/lead.dto"
import { StatusHistoryEntryDto } from "src/app/infrastructure/lobby-proxy/DTOs/status-history-entry.dto"

export const mapLeadDtoToLeadStatusTransitionArr = pipe(
    map((source: LeadDto) => statusHistoryEntryArrDtoToLeadStatusTransitionArr(source.statusHistory, source.created))
)

export function statusHistoryEntryArrDtoToLeadStatusTransitionArr(source: StatusHistoryEntryDto[], leadCreationDate: string): LeadStatusTransition[] {
    let transitions: LeadStatusTransition[] = []

    source.forEach(item => {

        let previousItem = source[source.indexOf(item) - 1]

        transitions.push(statusHistoryEntryDtoToLeadStatusTransition(item,
            previousItem?.processingStatus,
            new Date(previousItem?.transitionTime ?? leadCreationDate)
        ))
    })

    return transitions
}

function statusHistoryEntryDtoToLeadStatusTransition(source: StatusHistoryEntryDto, previousProcessingStatus: string | null, previousTransitionTime: Date): LeadStatusTransition {
    return {
        previousProcessingStatus: previousProcessingStatus ? ProcessingStatus[previousProcessingStatus as keyof typeof ProcessingStatus] : null,
        currentProcessingStatus: ProcessingStatus[source.processingStatus as keyof typeof ProcessingStatus],
        qualificationStatus: QualificationStatus[source.qualificationStatus as keyof typeof QualificationStatus],
        qualificationOutcome: QualificationOutcome[source.qualificationOutcome as keyof typeof QualificationOutcome],
        timeSpan: [previousTransitionTime, new Date(source.transitionTime)]
    } as LeadStatusTransition
}